import { QUESTION_PAGE_TOP_PADDING_VAR } from 'question-page-styles'
import styled, { css } from 'styled-components'

import {
  Color,
  HEADER_HEIGHT,
  SECTIONED_PROGRESS_HEADER_HEIGHT,
} from 'root-constants'

export const StyledButtonBase = css`
  width: 100%;
  height: 56px;
  display: block;
  padding: 0 15px;
  cursor: pointer;
  border: none;
  outline: none;
  background-color: ${Color.PRIMARY};
  border-radius: 30px;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-decoration: none;
  text-align: center;
  color: ${Color.WHITE};
  transition: background-color 0.2s ease-out;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
`

export const CommonLayout = styled.div<{
  isHeaderOverlay?: boolean
  hasHeader?: boolean
  $hasSectionedProgress?: boolean
  $background?: string
}>`
  position: relative;
  display: flex;
  flex-direction: column;

  height: ${({ isHeaderOverlay, hasHeader, $hasSectionedProgress }) => {
    if (isHeaderOverlay || !hasHeader) return 'var(--full-height, 100vh)'

    const headerHeight = $hasSectionedProgress
      ? SECTIONED_PROGRESS_HEADER_HEIGHT
      : HEADER_HEIGHT

    return `calc(var(--full-height, 100vh) - ${headerHeight}px)`
  }};

  ${({ $hasSectionedProgress }) =>
    $hasSectionedProgress &&
    css`
      ${QUESTION_PAGE_TOP_PADDING_VAR}: 24px;
    `}

  background: ${({ $background }) => $background || Color.SKY_BASE};
  font-family: 'Inter', sans-serif;
  * {
    font-family: inherit;
  }
`

export const Viewport = styled.div.attrs({ className: 'viewport-container' })<{
  $fillsViewport?: boolean
  $hasHeaderOffset?: boolean
}>`
  display: ${({ $fillsViewport }) => ($fillsViewport ? 'flex' : 'block')};
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  overscroll-behavior-y: contain;

  ${({ $hasHeaderOffset }) =>
    $hasHeaderOffset &&
    css`
      position: relative;

      padding-top: ${HEADER_HEIGHT}px;
    `}
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
